import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { adds } from '../configs/eslint-auto-fix-config';

/**
 * The class to upgrade the eslint to support 'gulp lintApp --fix'.
 */
export class EslintAutoFixUpgrader {
    private readonly fileName = '.eslintrc.json';
    private filePath: string;
    private fileWriter: FileWriter;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     */
    constructor(filePath: string) {
        this.filePath = filePath;
        this.messages.notFound = `${this.fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .addContent(adds)
                    .writeFile();
            } else {
                    Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
